import { useState } from "react";

export const Accordion = ({ items, testPrefix }) => {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid={`${testPrefix}-accordion`}>
      {items.map((item, i) => (
        <div key={i} className={`acc-item ${open === i ? "open" : ""}`}>
          <button
            className="acc-trigger"
            data-testid={`${testPrefix}-accordion-trigger-${i + 1}`}
            onClick={() => setOpen(open === i ? -1 : i)}
          >
            <span className="acc-num">{String(i + 1).padStart(2, "0")}</span>
            <span className="acc-title">{item.title}</span>
            <span className="acc-icon">+</span>
          </button>
          <div className="acc-body">
            <div className="acc-body-inner">
              <p>{item.body}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
